import { ISignable } from "@/mixins/SignalsMixin/interfaces";

export enum SignalType {
  Signal = "signal",
  NoSignal = "no-signal",
  Loading = "loading"
}

export enum SignalNotificationsType {
  All = "all",
  Relevant = "relevant",
  None = "none"
}

export enum SignableType {
  Person = "person",
  Organization = "organization",
}

export interface ISignalDetail {
  type: SignalType;
  notificationsType: SignalNotificationsType;
  personId: string | undefined;
  organizationId: number | undefined;
}

export class SignalDetail implements ISignable {
  public type: SignalType;
  public notificationsType: SignalNotificationsType;
  public personId: string | undefined;
  public organizationId: number | undefined;

  constructor(data: ISignalDetail) {
    this.type = data.type || SignalType.Signal;
    this.notificationsType = data.notificationsType || SignalNotificationsType.Relevant;
    this.personId = data.personId;
    this.organizationId = data.organizationId;
  }

  public signableId(): string | undefined {
    return (this.personId || (this.organizationId ? this.organizationId.toString() : undefined));
  }

  public signableType(): SignableType {
    return this.personId ? SignableType.Person : SignableType.Organization;
  }
}
